'use strict';

$(document).on('ajaxComplete', (event, jqXHR) => {
    const rebootHeader = jqXHR.getResponseHeader(Fotobook.Headers.HEADER_REBOOT_PENDING);
    Fotobook.store.commit('RebootPending/setRebootTime', rebootHeader);
});
